import { HttpLink } from '@apollo/client'
import { envs } from '@config'
import fetch from 'cross-fetch'

export const httpMiddleware = new HttpLink({
  uri: envs.graphqlHttpUrl,
  fetch,
})
